module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kathleen Sears\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kathleen Sears has a wide array of interests and enjoys taking a deep dive into new subject matter. She is the author of "), _c('I', [_vm._v("American Government 101")]), _vm._v(", "), _c('I', [_vm._v("Mythology 101")]), _vm._v(", "), _c('I', [_vm._v("US History 101")]), _vm._v(", "), _c('I', [_vm._v("Grammar 101")]), _vm._v(", and "), _c('I', [_vm._v("Weather 101")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fX6eOg/tc-custom/9781440573330.jpg?1723288490077",
      "alt": "This image is the cover for the book Mythology 101, Adams 101"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mythology 101, Adams 101\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Explore the fascinating myths of Greek and Roman civilizations, featuring gods like the mighty Zeus to monsters like the bull-headed minotaur.")]), _c('br'), _c('br'), _vm._v("The tales of gods and heroes are often turned into tedious discourse that even Ovid would reject. This easy-to-read guide cuts out the boring details, and instead, provides you with a thrilling lesson in classic mythology."), _c('br'), _c('br'), _vm._v("From the heights of Mt. Olympus to the depths of the Underworld, this book takes you on an unforgettable journey through all the major myths born in ancient Greece and Rome, such as Achilles’s involvement in the Trojan War; Pluto’s kidnapping of the beautiful Proserpina; and the slaying of Medusa by Perseus, the heroic demi-god. You’ll also learn all about the wonders of the world as well as the greatest creatures ever recorded in history."), _c('br'), _c('br'), _vm._v("Like Charon navigating the River of Wailing, "), _c('i', [_vm._v("Mythology 101")]), _vm._v(" will guide you through the most glorious (and completely terrifying) tales the ancient world has to offer.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0